// Copyright © 2024 The Things Industries B.V.

import { selectWebhooksConfiguration } from './application-server'

// eslint-disable-next-line import/prefer-default-export
export const selectWebhooksQueueConfiguration = state =>
  selectWebhooksConfiguration(state).queue || { enabled: false }
